import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { format } from 'date-fns';
import { getDate } from '../../configInfo/components/Functions';
import { event } from './Interfaces';

interface Props {
  event: event;
  delay: number;
  animate: boolean;
}

const Event: React.FC<Props> = ({ event, delay, animate }) => {
  let date = format(getDate(new Date(event.dateUTC)), 'MM/dd/yyyy, hh:mm:ssaaa');
  if (animate) {
    return (
      <>
        <div className="event">
          <Card>
            <CardContent>
              <Typography variant="body1">
                <b>Date: </b>
                {date}
              </Typography>
              <Typography variant="body1">
                <b>Type: </b>
                {event.type}
              </Typography>
              <Typography variant="body1">
                <b>Description: </b>
                {event.description}
              </Typography>
            </CardContent>
          </Card>
        </div>
      </>
    );
  } else {
    return (
      <div className="event">
        <Card>
          <CardContent>
            <Typography variant="body1">
              <b>Date: </b>
              {date}
            </Typography>
            <Typography variant="body1">
              <b>Type: </b>
              {event.type}
            </Typography>
            <Typography variant="body1">
              <b>Description: </b>
              {event.description}
            </Typography>
          </CardContent>
        </Card>
      </div>
    );
  }
};

export default Event;
